import { StyleSheet } from 'aphrodite';
import { brandPrimary, brandSecondary } from '../../../../web/styles/colors';
import { CssSelectors, DefaultBorder } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	backorderFormAddButton: {
		alignItems: 'center',
		color: brandPrimary,
		display: 'flex',
		fontSize: 14,
	},
	backorderFormAddButtonIcon: {
		marginRight: '0.5rem',
	},
	container: {
		display: 'block',
	},
	danger: {
		':hover': {
			backgroundColor: '#770000',
		},
		backgroundColor: 'red',
	},
	deactivateLevNumber: {
		':hover': {
			borderBottom: `1px solid ${brandPrimary}`,
		},
		borderBottom: `1px solid transparent`,
		color: brandPrimary,
	},
	dropDown: {
		':hover': {
			cursor: 'pointer',
		},
		background: 'white',
		border: DefaultBorder,
		borderRadius: 0,
		boxShadow: '0 2px 4px 0 rgba(0, 0, 0, .1)',
		fontSize: 14,
		height: 30,
		width: 160,
	},
	importForm: {
		maxWidth: 400,
	},
	importFormBody: {
		fontSize: '0.9rem',
	},
	phoneNumber: {
		margin: 0,
	},
	providerForm: {
		...CssSelectors.allChildren(
			{
				marginTop: '1rem',
			},
			':not(:first-child)'
		),
		display: 'flex',
		flexDirection: 'column',
	},
	providerFormBtnSpinner: {
		marginRight: '0.5rem',
	},
	providerFormHeader: {
		color: brandSecondary,
		fontSize: '1.25rem',
	},
	section: {
		display: 'flex',
		justifyContent: 'flex-start',
		margin: '20px 0px',
	},
	sectionColumn: {
		minWidth: 220,
	},
	sectionTitle: {
		color: '#858585',
		fontSize: 16,
		letterSpacing: 1,
		paddingTop: 20,
		textTransform: 'uppercase',
	},
	title: {
		color: brandPrimary,
		fontSize: 22,
		fontWeight: 600,
		maxWidth: '80%',
	},
});
